import { IconTypes } from './../../../shared/icon/icon.interfaces';
import { UiColors } from './../../../interfaces/ui.interfaces';
import { Component, Input, OnInit, SimpleChange, OnChanges } from '@angular/core';
import { mfHumanizeEventString } from 'app/shared/table/map-formatters.table.helpers';
import { TableColumn, TableDataMap } from 'app/shared/table/table.interfaces';
import { SharedService } from 'app/shared/shared.service';
import { ParcelTimelineItem } from 'app/shared/parcel-timeline/parcel-timeline.interface';

@Component({
  selector: 'app-courier-orders-timeline',
  templateUrl: './courier-orders-timeline.component.html',
  styleUrls: ['./courier-orders-timeline.component.scss'],
})
export class CourierOrdersTimelineComponent implements OnInit, OnChanges {
  @Input() orderId: string;
  @Input() refresh = false;
  @Input() orderWaybillNumber: string;
  parcelList = [];
  loading: boolean = false;

  timelineCourierRawData: ParcelTimelineItem[];

  UiColors = UiColors;
  IconTypes = IconTypes;

  timelineCourierColumns: TableColumn[] = [
    { name: 'parcel_waybill', displayName: 'Waybill' },
    { name: 'created_at', displayName: 'Created' },
    { name: 'event_name', displayName: 'Event' },
    { name: 'event_arg1', displayName: 'Event Arg 1' },
    { name: 'event_arg2', displayName: 'Event Arg 2' },
  ];
  timelineCourierDataMap: TableDataMap = {
    cells: {
      parcel_waybill: { column: 'parcel_waybill', map: 'ParcelWaybillNumber' },
      created_at: { column: 'created_at', map: 'Timestamp', displayPipeArgs: ['date', 'medium'] },
      event_name: {
        column: 'event_name',
        map: 'EventDescription',
        format: mfHumanizeEventString,
      },
      event_arg1: { column: 'event_arg1', map: 'EventArg1' },
      event_arg2: { column: 'event_arg2', map: 'EventArg2' },
    },
  };

  constructor(private sharedService: SharedService) {}

  ngOnInit(): void {
    this.loading = true;
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    if (changes.refresh && changes.refresh.currentValue === changes.refresh.previousValue) {
      return;
    }
    this.getTrackingEvents();
  }

  getTrackingEvents(): void {
    this.sharedService.getOrderTrackingEventsFromEndpoint(this.orderId).subscribe((response: ParcelTimelineItem[]) => {
      const initialData: ParcelTimelineItem[] = response;
      this.timelineCourierRawData = initialData.filter(
        (event) => event.ParcelWaybillNumber.split('_')[0] === this.orderWaybillNumber
      );
      this.timelineCourierRawData.forEach((event) => {
        if (this.parcelList.indexOf(event.ParcelWaybillNumber) === -1) {
          this.parcelList.push(event.ParcelWaybillNumber);
        }
      });
      this.loading = false;
    });
  }
}
